import React from 'react'
import AssetComponent from '../../../components/asset/Asset'
import { IAssetData } from '../../../helpers/data/assetData'
import { Wrapper, AvatarButton } from './AvatarStyles'

export interface IAvatarProps {
	id: string
	icon: IAssetData
}

class AvatarItem extends React.PureComponent<IAvatarProps> {

	render() {
		return (
			<Wrapper>
				<AvatarButton>
					<AssetComponent asset={this.props.icon} />
				</AvatarButton>
			</Wrapper>
		)
	}
}

export default AvatarItem
